import { render, staticRenderFns } from "./TicketPlantAdd.vue?vue&type=template&id=0beb95f6&"
import script from "./TicketPlantAdd.vue?vue&type=script&lang=js&"
export * from "./TicketPlantAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports